import { Route } from 'react-router-dom';
import { LoginPage } from '../pages/LoginPage';

export const authRoutes = [
  <Route key="login" path="/auth/login" element={<LoginPage />} />,
];